"use strict";

import googlechart from 'angular-google-chart';

export default angular.module("contartemx.inicio.resumen", [
	"contartemx",
	"ngTable",
	"ui.bootstrap",
	"datePicker",
	"tableTools",
	"loader",
	"googlechart"    
])
.controller("ResumenCtrl", ($scope, $state, $filter, callToWebService, mostrarNotificacion, $uibModal, onboarding) => {
    $scope.tieneTiposDeTransacciones = false;

    $scope.TiposIngreso = [];
    $scope.mensajeBienvenida = true;
    $scope.ocultarBienvenida = function () {
        $scope.mensajeBienvenida = false;
    }

    $scope.iconType = function (type) {
        switch (type) {
            case 1:
                return 'icon icon--contacts';
                break;
            case 2:
                return 'icon icon--document';
                break;
            case 3:
                return 'icon icon--box';
                break;
            case 4:
                return 'icon icon--user';
                break;
            case 5:
                return 'icon icon--certificate';
                break;
            case 6:
                return 'icon icon--calcultator';
                break;
            case 7:
                return 'icon icon--bank';
                break;
            case 8:
                return 'icon icon--office';
                break;

            default:
                break
        }

    }

    $scope.llenarTiposDeTransaccion = function (listData) {
        $scope.tiposTransaccionesCreacion = [];
        var c = 0;
        for (c = 0; c < listData.length; c++) {
            if(listData[c].EstaActivo){
                $scope.tieneTiposDeTransacciones = true;
                $scope.tiposTransaccionesCreacion.push({
                "Nombre": listData[c].Nombre
                });
            }
        }
    };


  //   $scope.opcionesInicales = [
		// { Cve: 1, Nombre: 'Registra tu primer cliente' },
		// { Cve: 2, Nombre: 'Genera tu primer factura' },
		// { Cve: 3, Nombre: 'Registra articulos para venta' },
		// { Cve: 4, Nombre: 'Invita a tus contactos' }
  //   ];

  //   $scope.recordatorios = [
		// { Cve: 1, Asunto: 'Angel sanches debe 4 facturas atrasadas desde abril 2013.', Persona: '' },
		// { Cve: 1, Asunto: 'Tienes una factura atrasada con Jorge Arroyo.', Persona: '' },
		// { Cve: 1, Asunto: 'Alejandro Figueroa tiene un recibo de honorarios proximo a vencer.', Persona: '' },
		// { Cve: 1, Asunto: 'Quedan 50 timbres CFDI. Adquiere mas aqui antes de que se te termien.', Persona: '' },
		// { Cve: 1, Asunto: 'Factura atrasada', Persona: '' },
		// { Cve: 1, Asunto: '', Persona: '' },
		// { Cve: 1, Asunto: '', Persona: '' }
  //   ];

    $scope.reminderLimit = 4;
    $scope.increaseReminderLimit = function () {
        $scope.reminderLimit = $scope.recordatorios.length;
    };
    $scope.decreaseReminderLimit = function () {
        $scope.reminderLimit = 4;
    };

    $scope.beginLimit = 4;
    $scope.increaseBeginLimit = function () {
        $scope.beginLimit = $scope.opcionesInicales.length;
    };
    $scope.decreaseBeginLimit = function () {
        $scope.beginLimit = 4;
    };


    $scope.hidePanelInicio = function (panel) {
        switch (panel) {
            case 1:
                $scope.logo = false;
                break;
            case 2:
                $scope.correos = false;
                break;
            case 3:
                $scope.facturas = false;
                break;
            case 4:
                $scope.sucursales = false;
                break;
            case 5:
                $scope.clientes = false;
                break;
            default:
                $scope.logo = false;
                $scope.correos = false;
                $scope.facturas = false;
                $scope.sucursales = false;
                $scope.clientes = false;
                break;
        }

    };

    $scope.logo = true;
    $scope.correos = true;
    $scope.facturas = true;
    $scope.sucursales = true;
    $scope.clientes = true;

    $scope.chartArticulos = true;
    $scope.chartClientes = false;
    $scope.chartSucursales = false;

    $scope.chooseChart = function (chartChoosen) {

        $scope.chartArticulos = false;
        $scope.chartClientes = false;
        $scope.chartSucursales = false;
        switch (chartChoosen) {
            case 1:
                $scope.chartArticulos = true;
                break;

            case 2:
                $scope.chartClientes = true;
                break;

            case 3:
                $scope.chartSucursales = true;
                break;

            default:
                break;
        }
    }

    $scope.llenarIngresosGastos = function (chartData) {
        var rows = [];
        var c;
        for (c = 0; c < chartData.length; c++) {
            rows.push({
                c: [
                    { v: chartData[c].NombreMes },
                    { v: chartData[c].Ventas, f: $filter('currency')(chartData[c].Ventas, "$") },
                    { v: chartData[c].Cobros, f: $filter('currency')(chartData[c].Cobros, "$") },
                    { v: chartData[c].Gastos, f: $filter('currency')(chartData[c].Gastos, "$") },
                ]
            });
        }

        var chart2 = {};
        chart2.type = "ColumnChart";
        chart2.cssStyle = "height:350px; width:300px;";

        chart2.data = {
            "cols": [
                { id: "month", label: "Month", type: "string" },
                { label: "Facturado", type: "number" },
                { label: "Cobrado", type: "number" },
                { label: "Gastado", type: "number" }
            ], "rows":
                rows
        };

        chart2.options = {
            "focusTarget": "category",
            "isStacked": "false",
            "fill": 20,
            "displayExactValues": true,
            "orientation": "horizontal",
            "backgroundColor": "#f2f4f4",
            "colors": ['#A9A9A9', '#2999CF', '#F2622F', '#1EB800', '#B72EC3', '#2232FF'],
            "vAxis": {
                "title": "", "gridlines": { "count": 6 }
            },
            "hAxis": {
                "title": ""
            },
            "legend": {
                "position": "top"
            }
        };

        chart2.formatters = {};

        $scope.IngresosEgresos = chart2;
    };

    $scope.llenarArticulosMasVendidos = function (chartData) {
        $scope.ArticulosVendidos = null;
        if (chartData.length > 0) {
            var rows = [];
            var cols = [];
            var c;
            for (c = 0; c < chartData.length; c++) {
                rows.push({
                    c: [
                        { v: chartData[c].producto },
                        { v: chartData[c].monto, f: $filter('currency')(chartData[c].monto, "$") }
                    ]
                });
            }

            cols =
                [
                { id: "t", label: "Producto", type: "string" },
                { id: "s", label: "Slices", type: "string" }
                ];

            var chart1 = {};
            chart1.formatters = {};
            chart1.type = "PieChart";
            chart1.cssStyle = "";

            chart1.data = {
                "cols": cols,
                "rows": rows
            };
            chart1.options = {
                "isStacked": "true",
                "fill": 20,
                "pieHole": .45,
                "backgroundColor": "#f2f4f4",
                "fontSize": 12,
                "height": 300,
                "width": 422,
                "chartArea":{ "width":422, "left": 0 },
                //"legend.maxLines": 2,
                "colors": ['#4F8BEB', '#ED5814', '#FDBB00', '#1EB800', '#B72EC3', '#2232FF']
            };
            $scope.ArticulosVendidos = chart1;
        }
    };

    $scope.llenarArticulosMasComprados = function (chartData) {
        $scope.ArticulosComprados = null;
        if (chartData.length > 0) {
            var rows = [];
            var cols = [];
            var c;
            for (c = 0; c < chartData.length; c++) {
                rows.push({
                    c: [
                        { v: chartData[c].producto },
                        { v: chartData[c].monto, f: $filter('currency')(chartData[c].monto, "$") }
                    ]
                });
            }

            cols = 
                [
                {id: "t", label: "Producto", type: "string"},
                {id: "s", label: "Slices", type: "string"}
            ];
            var chart1 = {};
            chart1.format = {};
            chart1.type = "PieChart";
            chart1.cssStyle = "";
            
            chart1.data = {
                "cols": cols,
                "rows": rows
            };

            var options = {
                "isStacked": "true",
                "fill": 20,
                "pieHole": .45,
                "backgroundColor": "#f2f4f4",
                "fontSize": 12,
                "height": 300,
                "width": 422,
                "chartArea":{ "width":422, "left": 0 },
                "colors": ['#4F8BEB', '#ED5814', '#FDBB00', '#1EB800', '#B72EC3', '#2232FF']
            };
            chart1.options = options;
            $scope.ArticulosComprados = chart1;
        }
    };

    $scope.llenarCuentaPorCobrar = function (chartData) {
        var rows = [];
        var c;
        for (c = 0; c < chartData.Entradas.length; c++) {
            rows.push({
                c: [
                    { v: chartData.Entradas[c].Rango },
                    { v: chartData.Entradas[c].Monto, f: $filter('currency')(chartData.Entradas[c].Monto, "$") }
                ]
            });
        }

        var chart2 = {};
        chart2.type = "ColumnChart";
        chart2.cssStyle = "height:350px; width:300px;";

        chart2.data = {
            "cols": [
                { id: "month", label: "Month", type: "string" },
                { label: "Por Cobrar (días)", type: "number", opacity: 0.2 },
            ], "rows":
                rows
        };

        chart2.options = {
            "title": "Total por cobrar = " + $filter('currency')(chartData.Total, "$"),
            "focusTarget": "category",
            "isStacked": "false",
            "fill": 20,
            "displayExactValues": true,
            "orientation": "horizontal",
            "backgroundColor": "#f2f4f4",
            "colors": ['#2999CF'],
            "vAxis": {
                "title": "", "gridlines": { "count": 6 }
            },
            "hAxis": {
                "title": ""
            },
            "legend": {
                "position": "top"
            }
        };

        chart2.formatters = {};

        $scope.CuentaPorCobrar = chart2;
        $scope.TotalPorCobrar = chartData.Total;
    };

    //-----------------------------------------------------------------------
    $scope.navegarAMejorasPrecios = function() {
        $state.go('administracion.cuenta_detalle', { cveContribuyente: $scope.userInfo.ClaveContribuyente});
    }

    $scope.cerrarAdvertencia = function (i) {
        if (i == 1) {
            $scope.OcultarTimbres = true;
        }
        else if (i == 2) {
            $scope.OcultarMembresias = true;
        }
    }
    //----------------------modal nuevo tipo factura
    $scope.displayTiposIngreso = function () {
        var modalInstance = $uibModal.open({
            template: require('../../../../../app/views/Inicio/Resumen/tipoFactura_modal.html'),
            controller: TiposIngresoCtrl,
            windowClass: 'modal--small',
            resolve: {
                tiposIngreso: function () {
                    return $scope.TiposIngreso;
                }
            }
        });
        modalInstance.result.then(function (data) {
            if(data.CodigoRespuesta == 200)
            {
                $scope.llamado = false;
                ObtenerPantallaResumen();
            }
        });
    };

    function ObtenerPantallaResumen() {
        callToWebService.postCall('ObtenerPantallaResumen', {},
            function sucess(data) {
                if (data.Respuesta != null) {
                    $scope.NotificarTimbres = data.Respuesta.NotificarTimbres;
                    $scope.NotificarMembresia = data.Respuesta.NotificarMembresia;
                    $scope.DiasRestantes = data.Respuesta.DiasRestantes;
                    $scope.TimbresRestantes = data.Respuesta.TimbresRestantes;
                    $scope.TiposIngreso = data.Respuesta.TiposDeIngresoDisponibles;
                    $scope.llenarTiposDeTransaccion(data.Respuesta.TiposDeIngresoDisponibles);
                    $scope.TieneMovimientos = !data.Respuesta.NoTieneMovimientos;
                    $scope.NoTieneMovimientos = data.Respuesta.NoTieneMovimientos;
                }
            },
            function error(data) {
                mostrarNotificacion.error(data.Mensaje);
            });
    }

    ObtenerPantallaResumen();

    var reportParams = [
        { name: 'ObtenerGraficaIngresosGastos', handler: $scope.llenarIngresosGastos },
        { name: 'ObtenerGraficaCuentasPorCobrar', handler: $scope.llenarCuentaPorCobrar },
        { name: 'ObtenerGraficaProductosVendidos', handler: $scope.llenarArticulosMasVendidos },
        { name: 'ObtenerGraficaProductosComprados', handler: $scope.llenarArticulosMasComprados }
    ];

    function handleChart(serviceName, callback) {
        callToWebService.postCall(serviceName, {}, 
          function success(data){
                if(!data || data.EsError) {
                    //handleError(data);
                    return angular.noop();
                }
                callback(data.Respuesta);
            },
          angular.noop
          //function (data) { handleError(data) }
        );
    };

    function handleError(data) {
        var messaje = data ? data.mensajeBienvenida : 'Hubo un error al cargar los datos';
        mostrarNotificacion.error(messaje);
    }

    for(var i in reportParams) {
        handleChart(reportParams[i].name, reportParams[i].handler);
    }

    var TiposIngresoCtrl = function ($scope, $uibModalInstance, $http, tiposIngreso) {

        $scope.tiposIngresoModal = tiposIngreso;

        $scope.saveChanges = function(){
        var tiposIngresosEnviar =[];
        for(var x = 0; x < $scope.tiposIngresoModal.length ;x++)
        {
            tiposIngresosEnviar.push({EstaActivo:$scope.tiposIngresoModal[x].EstaActivo,CveTipoTransaccion:$scope.tiposIngresoModal[x].ClaveTipoDeIngreso})
        }

        var ingreso = { 
                TiposDeIngreso: tiposIngresosEnviar
            };
        callToWebService.postCall('ActualizarTiposDeIngreso', ingreso,
          function sucess(data){
                if (data && data.CodigoRespuesta) {
                    if (data.CodigoRespuesta != 500) {
                        $uibModalInstance.close(data);
                    } else {
                    }
                } else {
                }
            },
            function error(data){
            });

        
        };

        $scope.closeModal = function (respuesta) {
            $uibModalInstance.dismiss('cancel');
        };
    };
});
